import { ref } from 'vue'
import { START_LOCATION } from 'vue-router'
import { useStore } from '@/stores/main'

const showPageSpeedBump = ref(false)
let pendingResolve = null

const getDestinationSlug = (route) => {
  if (route.name === 'Home') {
    return window.__VUE_WORDPRESS__.routing.page_on_front
  }

  if (route.name === 'Page') {
    return route.params.slugs[0]
      .split('/')
      .filter((s) => s)
      .pop()
  }

  return null
}

const settle = (allowNavigation) => {
  showPageSpeedBump.value = false
  pendingResolve?.(allowNavigation)
  pendingResolve = null
}

// Router guard: pages with "Show Speed Bump" enabled ask for confirmation when
// reached by navigating within the site (not on a direct landing). It shows
// every time.
export const pageSpeedBumpGuard = async (to, from) => {
  if (from === START_LOCATION || to.path === from.path) return true

  const slug = getDestinationSlug(to)
  if (!slug) return true

  const store = useStore()

  try {
    await store.getSingleBySlug({ type: 'pages', slug })
  } catch {
    return true
  }

  const page = store.getCurrentSingleBySlug({ type: 'pages', slug })
  const enabled = [true, 1, '1'].includes(page?.acf?.show_speed_bump)

  if (!enabled) return true

  return new Promise((resolve) => {
    // A newer navigation replaces any bump that is still waiting.
    pendingResolve?.(false)
    pendingResolve = (allow) => resolve(allow)
    showPageSpeedBump.value = true
  })
}

export function usePageSpeedBump() {
  return {
    showPageSpeedBump,
    confirm: () => settle(true),
    cancel: () => settle(false),
  }
}
